module.exports = __webpack_public_path__ + "static/img/4.6b33315f.png";